// extracted by mini-css-extract-plugin
export default {"fieldsWrapper":"EnquiryInformation_fieldsWrapper__Z1UPE","wrapper":"EnquiryInformation_wrapper__Dwi28"};